import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit"

import {
  ChoiceTranslation,
  SubQuestion,
  SurveyCategory,
  SurveyMode,
  SurveyTypes,
} from "#types/api";

export interface OrganizationOption {
  id: number;
  value: number;
  label: string;
}

export interface SubQuestionWithSubmodule extends SubQuestion {
  submodule: number;
  submodule_id: string;
}

export interface SurveyFormState {
  name: string;
  organizations: OrganizationOption[];
  category?: SurveyCategory | null;
  type?: SurveyTypes | null;
  mode?: SurveyMode | null;
  attributes: number[];

  submodules: number[];
  indicators: number[];
  submodules_order: number[];
  // NOTE: This is not accepted on the server. Just keeping this here for
  // consistency
  indicators_order: number[];

  sub_questions: SubQuestionWithSubmodule[];

  languages: ChoiceTranslation[];
}

const initialState: SurveyFormState = {
  name: "",
  organizations: [],
  category: null,
  type: null,
  mode: null,
  attributes: [],

  submodules: [],
  indicators: [],
  submodules_order: [],
  indicators_order: [],

  sub_questions: [],

  languages: [{ language: "en", language_display: "English" }],
};

const surveyFormSlice = createSlice({
  name: "surveyForm",
  initialState,
  reducers: {
    setSurveyData: (
      state,
      action: PayloadAction<Partial<SurveyFormState>>
    ) => ({
      ...state,
      ...action.payload,
    }),
    resetSurveyData: (
      // state,
      // action: PayloadAction<Partial<SurveyFormState>>
    ) => ({
      ...initialState,
    }),
  },
});

export default surveyFormSlice.reducer;

export const surveyFormActions = surveyFormSlice.actions;
